import * as React from 'react';

import CenteredContainer, { LoadingIndicatorBackgroundColor } from 'components/CenteredContainer';
import LoadingIndicator, { Props as LoadingIndicatorProps } from 'components/LoadingIndicator';

/**
 * ## [LoadingIndicator](/internal/components/LoadingIndicator) wrapped in a [CenteredContainer](/internal/components/CenteredContainer).
 * ### In order for vertical centering to occur, its parent must have an explicitly set height (a min-height is not sufficient).
 *
 * ```example
 * <CenteredLoadingIndicator />
 * ```
 *
 *
 * # TODO
 * * Reconcile with other loaders
 */

function CenteredLoadingIndicator(
  props: LoadingIndicatorProps & { backgroundColor?: LoadingIndicatorBackgroundColor }
) {
  // when this was converted to typescript, wholesale passing down
  // props was causing a few snapshots to fail, so this is just a
  // safety measure
  const { backgroundColor, ...others } = props;

  return (
    <CenteredContainer
      backgroundColor={backgroundColor}
      className="CenteredLoadingIndicator-container"
      data-testid="CenteredLoadingIndicator"
    >
      <LoadingIndicator align="center" {...others} />
    </CenteredContainer>
  );
}

export default CenteredLoadingIndicator;
